<div class="bg-black-footer">
    <div class="container">
        <div class="row">
            <div class="col-md-7 col-12 img-svg">
                <div class="w-161">
                    <a [innerHTML]="svgContent" href="#"></a>
                </div>
            </div>
            <div class="col-md-5 col-12">
                <div class="footer-nav-items">
                    <div class="section-al">
                        <a class="header-names home-bt" href="#">Home</a>
                    </div>
                    <div class="section-al">
                        <a class="header-names about-bt" style="cursor: pointer;" routerLink="/about-us">About
                            Us</a>
                            <!-- (click)="scrollUpToAboutus()" -->
                    </div>
                    <div class="section-al">
                        <a routerLink="/contact-us" class="header-names contact-bt"
                            style="cursor: pointer;">Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row footer-al">

        <div class="col-md-12 footer-tx">© 2023 Gameday. All right Reserved</div>
    </div>
</div>